import { gql } from '@apollo/client'
import { NOTIFICATION_FIELDS } from './fragments/notification'

export const ACTIVE_NOTIFICATIONS = gql`
  ${NOTIFICATION_FIELDS}
  query activeNotifications {
    activeNotifications {
      notifications {
        ...NotificationFields
      }
    }
  }
`
